import { cryptoId } from "../utils";
import { JobBase, JobName } from "./job";
export class AirdropJob extends JobBase {
    constructor(params) {
        super(Object.assign(Object.assign({}, params), { name: JobName.AIRDROP_NFT }));
        this.code = params.code || cryptoId(4);
        this.data = params.data;
    }
}
